<script>
	import { Button } from "$lib/components/atoms/Button";

  export let label = ""
  export let isLoading = false
</script>

<div class="load-more">
  <Button color="grey" isLoading="{isLoading}" disabled="{isLoading}" on:click>
    {label}
  </Button>
</div>

<style type="text/scss" lang="scss" scoped>
  .load-more {
    @apply w-full;
    @apply flex justify-center;
    @apply pb-8 lg:pb-10;
  }
</style>
